import optimumIcon from "../../assets/icons/optimumIcon.svg";
import "./navBar.css";
import userProfileImage from "../../assets/icons/avatar.png";
import userProfileDownArrow from "../../assets/icons/white-arrow-down.svg";
import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import UserService from "../../keycloak/UserService";

export default function NavBar() {
  const [open, close] = useState(false);
  const dropdownRef = useRef();
  const { userData } = useSelector((state) => state.auth);
  const location = useLocation();

  const openDropdown = () => {
    close(!open);
  };

  const logout = () => {
    localStorage.clear();
    UserService.doLogout({ redirectUri: window.location.origin });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        close(false);
      }
    };
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <div className="navbar-container">
      <a href="/">
        <img alt="Optimum Icon" src={optimumIcon} />
      </a>
      {/* {((location.pathname !== "/credit-card-form" &&
        location.pathname !== "/credit-card-submit-success" &&
        location.pathname !== "/page-not-found") ||
        UserService.isLoggedIn) && ( */}
      {userData && (
        <button
          ref={dropdownRef}
          className="user-profile"
          onClick={openDropdown}
        >
          <img
            className="profile-icon"
            src={userProfileImage}
            alt="user profile image"
          />
          {userData && <p>{`${userData?.firstName} ${userData?.lastName}`}</p>}
          <img
            className="down-arrow"
            src={userProfileDownArrow}
            alt="down arrow"
          />
          {open && (
            <ul className="option-list">
              <li onClick={logout}>Logout</li>
            </ul>
          )}
        </button>
      )}
    </div>
  );
}
